import React, {Suspense, lazy} from 'react';
const CategoryPageComponent = lazy( () => import('./category-page-realestate-class'));

function CategoryPage(props) {
  return <Suspense fallback="Loading..."><CategoryPageComponent {...props} /></Suspense>;
}

export default CategoryPage;